"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesColumn = exports.keyMetricColumn = exports.dimensionTypeColumn = exports.publicationStatusColumn = exports.actionsColumn = exports.allEnabledLanguagesColumn = exports.sourceTypeColumn = exports.selectedQuestionsColumn = exports.totalQuestionsColumn = exports.dimensionNameColumn = exports.dimensionIndexNameColumn = exports.expandColumn = exports.DimensionViewColumnHelper = exports.DimensionFilterHelper = exports.ClientIndicesOption = exports.ClientDimensionOption = exports.kincentricIndicesOption = exports.kincentricDimensionOption = exports.allDimensionsIndiciesOption = void 0;
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var enum_1 = require("../../models/enum");
var getLibraryDimensionListColumns = function () {
    return [
        exports.dimensionIndexNameColumn,
        exports.totalQuestionsColumn,
        exports.sourceTypeColumn,
        exports.publicationStatusColumn,
        exports.dimensionTypeColumn,
        exports.languagesColumn,
        exports.actionsColumn,
    ];
};
var getDimensionListColumns = function () {
    return [exports.dimensionNameColumn, exports.selectedQuestionsColumn, exports.sourceTypeColumn, exports.allEnabledLanguagesColumn, exports.actionsColumn];
};
exports.allDimensionsIndiciesOption = {
    displayText: contentConstants_1.default.DIMENSION_FILTER_ALL_DIMENSIONS_INDICES,
    name: enum_1.DimensionFilterOption.AllDimensionsIndices,
};
exports.kincentricDimensionOption = {
    displayText: contentConstants_1.default.DIMENSION_FILTER_KINCENTRIC_LIBRARY_DIMENSIONS,
    name: enum_1.DimensionFilterOption.KincentricDimensions,
};
exports.kincentricIndicesOption = {
    displayText: contentConstants_1.default.DIMENSION_FILTER_KINCENTRIC_LIBRARY_INDICES,
    name: enum_1.DimensionFilterOption.KincentricIndices,
};
exports.ClientDimensionOption = {
    displayText: contentConstants_1.default.DIMENSION_FILTER_CLIENT_LIBRARY_DIMENSIONS,
    name: enum_1.DimensionFilterOption.ClientDimensions,
};
exports.ClientIndicesOption = {
    displayText: contentConstants_1.default.DIMENSION_FILTER_CLIENT_LIBRARY_INDICES,
    name: enum_1.DimensionFilterOption.ClientIndices,
};
var getAllDimensionListFilterOptions = function () {
    return [exports.allDimensionsIndiciesOption, exports.kincentricDimensionOption, exports.kincentricIndicesOption, exports.ClientDimensionOption, exports.ClientIndicesOption];
};
var getKincentricDimensionListFilterOptions = function () {
    return [exports.allDimensionsIndiciesOption, exports.kincentricDimensionOption, exports.kincentricIndicesOption];
};
exports.DimensionFilterHelper = {
    getAllDimensionListFilterOptions: getAllDimensionListFilterOptions,
    getKincentricDimensionListFilterOptions: getKincentricDimensionListFilterOptions,
};
exports.DimensionViewColumnHelper = {
    getDimensionListColumns: getDimensionListColumns,
    getLibraryDimensionListColumns: getLibraryDimensionListColumns,
};
exports.expandColumn = {
    displayText: '',
    name: 'expandColumn',
    checked: true,
    displayOrder: 0,
    disabled: true,
};
exports.dimensionIndexNameColumn = {
    displayText: 'Dimension/Index Name',
    name: 'dimensionName',
    checked: true,
    displayOrder: 1,
    disabled: true,
    sortAscByDefault: true,
    isSortable: true,
};
exports.dimensionNameColumn = {
    displayText: 'Dimension Name',
    name: 'dimensionName',
    checked: true,
    displayOrder: 1,
    disabled: true,
    sortAscByDefault: true,
    isSortable: true,
};
exports.totalQuestionsColumn = {
    displayText: 'Total Questions',
    name: 'totalQuestions',
    checked: true,
    displayOrder: 2,
    disabled: true,
    sortAscByDefault: true,
    isSortable: true,
};
exports.selectedQuestionsColumn = {
    displayText: 'Selected Questions',
    name: 'selectedQuestions',
    checked: true,
    displayOrder: 3,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
exports.sourceTypeColumn = {
    displayText: 'Source',
    name: 'sourceType',
    checked: true,
    displayOrder: 4,
    disabled: true,
    sortAscByDefault: true,
    isSortable: false,
};
exports.allEnabledLanguagesColumn = {
    displayText: 'All Enabled Languages',
    name: 'allEnabledLanguages',
    checked: true,
    displayOrder: 5,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
exports.actionsColumn = {
    displayText: 'Actions',
    name: 'actions',
    checked: true,
    displayOrder: 6,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
exports.publicationStatusColumn = {
    displayText: 'Status',
    name: 'status',
    checked: true,
    displayOrder: 4,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
exports.dimensionTypeColumn = {
    displayText: 'Type',
    name: 'dimensionType',
    checked: true,
    displayOrder: 5,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
exports.keyMetricColumn = {
    displayText: 'Key Metric',
    name: 'keyMetric',
    checked: true,
    displayOrder: 6,
    disabled: true,
    sortAscByDefault: false,
    isSortable: true,
};
exports.languagesColumn = {
    displayText: 'Languages',
    name: 'languages',
    checked: true,
    displayOrder: 7,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
